import React from "react";
import { useSelector, useDispatch } from 'react-redux';
import UserForm from './UserForm';
import UserList from './UserList'; // Import the new UserList component
import GlobalPopup from "../../component/Popup/GlobalPopup.js";
import { openGlobalPopup, editUser } from "../../redux/action";
import { useIsMobile } from "../../component/Hooks/useIsMobile.js";
import UserMobileList from "./UserMobileList.js";
import "./User.css";

function RoleManagement() {
    const availableRoles = [{ Key: 'admin', value: 1 }, { Key: 'manager', value: 2 }, { Key: 'staff', value: 3 }, { Key: 'cashier', value: 4 }]
    // ['admin', 'manager', 'staff'];

    // handleAddUser is no longer needed here as UserForm dispatches directly
    // The list of other admin functionalities is kept as comments.
    const [showAddUser, setShowAddUser] = React.useState(false);
    const edit = useSelector((state) => state?.admin?.edit)
    const userSaving = useSelector((state) => Boolean(state?.admin?.userSaving));
    const dispatch = useDispatch();
    const isMobile = useIsMobile();

    const closePopUp = () => {
        dispatch(editUser(null));
    }

    const openAddUser = () => {
        dispatch(editUser(null));
        dispatch(openGlobalPopup("add-user"));
    };

    return (
        <div className='container'>
            <h1 style={{ padding: "0px 0px 0px 10px" }}>Manage Users</h1>
            <button
                className='add-button ui-page-add-button'
                onClick={openAddUser}
            >
                Add New User
            </button>

            <GlobalPopup
                popupKey={edit?.userId ? "edit-user" : "add-user"}
                title={edit?.userId ? 'Edit User' : 'Add New User'}
                onClose={closePopUp}
                disableClose={userSaving}
                footer={(closePopup) => (
                    <>
                        <button type="button" className="popup-action-btn secondary" onClick={closePopup} disabled={userSaving}>Cancel</button>
                        <button type="submit" form="user-form" className="popup-action-btn" disabled={userSaving} aria-busy={userSaving}>
                            {userSaving ? <><span className="popup-button-spinner" aria-hidden="true" />Saving...</> : edit?.userId ? 'Edit User' : 'Add User'}
                        </button>
                    </>
                )}
            >
                <UserForm roles={availableRoles} edit={edit?.userId ? edit : undefined} showForm={setShowAddUser} />
            </GlobalPopup>

            {/* Section for listing existing users */}
            <section className='list-section'>
                {isMobile ? (
                <UserMobileList/>
            ) : (
                    <UserList />
            )} 
            </section>


        </div>
    );
}

export default RoleManagement;
